var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremablockFlexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Lager_1",
    width: 544.832,
    height: 55.049,
    "data-name": "Lager 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-18.4 -18.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    d: "M18.4 18.22h216.63V48.7H18.4z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:none}.cls-4{fill:#0055a0}"))), /*#__PURE__*/React.createElement("path", {
    id: "rect1-7",
    d: "M349.3.3H365v54.5h-15.7z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M250.8 0h15.3v54.8h-15.3z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3",
    d: "M211.3.5h14.9v54.3h-14.9z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4",
    d: "M0 .5h19.4v54.3H0z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M42.2 7c3.6 5.3 2.6 14.1-.1 19.5-3.4 6.6-11.7 6.4-18.8 6.3V.5C30.9-.2 38.6.8 42.2 7z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m371.4 34.2.8 1.4c6 6.3 11.8 12.7 17.8 19.1h-21.2V15.6h17.9z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M304.3 22.2c4.2 6.3 4.3 15.9 1.3 22.8-2.2 5.8-8.9 9.4-15.4 9.8l-.1-40a15.46 15.46 0 0 1 14.2 7.4z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6",
    d: "M328.8 15.68h16.6v17.7z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M327.7 49.58c.2.6.6 1.2 1.3 1.2 6.8.6 13-3.8 16.2-9.2-.2 3 1.5 7.5-2.5 8.9-5.6 4-14.2 5.9-21 3a19.73 19.73 0 0 1-11.5-16.8c-.6-7.4 1.9-14.5 8-18.5 2.9-1.2 5.9-2.4 9.4-2.4Z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M286.8 54.7c-5.9-.5-12-2.6-14.9-7.9-4.1-6.6-3.9-16.7-.1-23.3 2.8-5.5 8.6-8.6 15-8.4z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M110.7 19.96c3.1 3.8 4 9 3.9 14.4h-14.4v-19.1c4 .3 8.1 1.1 10.5 4.7z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M96.6 49.96c1.2 1.4 3.6.9 5.4.8 5.5-.9 9.3-5.4 12.2-9.3v5.9c-4.8 6.1-12.2 8.6-20 7-7.6-1.7-12.6-7.2-14.1-15-1.5-8.8 1.7-17 8.3-22a14.2 14.2 0 0 1 8.2-1.8z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M76.7 17.1a8.78 8.78 0 0 1 2.2 5.9 7.37 7.37 0 0 1-2.6 5.4 8.19 8.19 0 0 1-7.7 1.2 8.38 8.38 0 0 1-4.7-6.1 7.2 7.2 0 0 1 3-7c2.6-2.1 7.4-1.7 9.8.6z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M244.8 22c3.7 6.9 4.1 17.3 1 24.5-2.4 5.7-8.8 8.4-15.3 8.1h-.4V15.9c5.8-.2 11.8 1.5 14.7 6.1z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    d: "M137 15.9h15v38.9h-15z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13",
    d: "M117.9 15.9h15.3v38.9h-15.3z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M170 21.2c1.3 2.8 1.1 6.1 1.1 9.5v24.1h-15.5V16c5.6-.2 12.1-.5 14.4 5.2z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M208.2 23.2c.9 10.2.3 21.1.5 31.6h-15.2l-.1-33a9 9 0 0 0-3-4.9c6.7-2.3 15-.2 17.8 6.3z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect14",
    d: "M47.3 15.4h15.4v39.4H47.3z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M191.5 21.9c.8 1.9.2 3.6-.3 5.4a8.13 8.13 0 0 1-7.2 4.3c-3.2-.3-6.3-2-7.1-5.3a8.12 8.12 0 0 1 2.4-8.1c2.2-2.1 5.7-2.1 8.3-1a8.65 8.65 0 0 1 3.9 4.7Z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M191.1 54.8c-5.9.2-12.5.3-15.3-4.9a12 12 0 0 1-.7-9.8c2.7-6 9.6-6.6 16-6.1z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M381.95 11.17a6.44 6.44 0 0 1-11-4.58 6.45 6.45 0 0 1 12.89 0 6.26 6.26 0 0 1-1.89 4.58zm-8.49-8.5a5.63 5.63 0 0 0 0 7.88 5.52 5.52 0 0 0 7.85 0 5.41 5.41 0 0 0 1.62-3.95 5.54 5.54 0 0 0-9.47-3.93zm3.8.36a5.4 5.4 0 0 1 1.93.25 1.76 1.76 0 0 1 1.1 1.8 1.56 1.56 0 0 1-.69 1.4 2.59 2.59 0 0 1-1 .34 1.72 1.72 0 0 1 1.21.69 2 2 0 0 1 .39 1.1v.52a5 5 0 0 0 0 .53 1.15 1.15 0 0 0 .06.37v.08h-1.17v-.07a.19.19 0 0 1 0-.08v-.78a1.71 1.71 0 0 0-.67-1.62 2.85 2.85 0 0 0-1.38-.23h-1v2.78h-1.25V3.03Zm1.34 1.12a3.2 3.2 0 0 0-1.51-.27h-1.07v2.57h1.13a3.3 3.3 0 0 0 1.19-.16 1.27 1.27 0 0 0 .26-2.14z",
    className: "cls-1",
    style: {
      fill: "#0055a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M444.065 12.28a8.26 8.26 0 0 0-5.664-2.868c-2.795 0-4.973 2.124-5.064 6.426h10.728v8.006h-10.8v30.66h-9.077v-30.66h-5.9v-8.006h6.045c.599-9.893 6.571-14.812 13.832-14.812 4.067 0 7.842 1.67 11.854 6.045zm7.66 42.224V1.643h9.077v52.861Z",
    className: "cls-4",
    style: {
      fill: "#e31818",
      strokeWidth: 1.81529
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M505.785 38.657h-28.936c.617 4.447 5.446 8.005 10.057 8.005a14.522 14.522 0 0 0 10.637-5.3l6.118 5.59a21.783 21.783 0 0 1-16.755 8.097 19.968 19.968 0 1 1-.09-39.937 19.115 19.115 0 0 1 19.368 19.914 37.704 37.704 0 0 1-.399 3.63zm-18.97-15.122a10.42 10.42 0 0 0-9.893 7.116h19.115a9.421 9.421 0 0 0-9.222-7.043z",
    className: "cls-4",
    style: {
      fill: "#e31818",
      strokeWidth: 1.81529
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m533.886 54.504-8.605-11.926-8.532 11.926h-10.891l13.977-19.478-13.65-19.188h10.891l8.169 11.328 8.169-11.328h11.037l-13.67 19.188 14.05 19.55z",
    className: "cls-4",
    style: {
      fill: "#e31818",
      strokeWidth: 1.81529
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremablockFlexLogo);
export default __webpack_public_path__ + "static/media/Premablock_Flex_Logo.f14053912b7746b77ea63c27b94032eb.svg";
export { ForwardRef as ReactComponent };